export const pendoPublicKey = "2c7961ea-f861-45be-6486-0fbe5ca184c2";
